module.exports = __webpack_public_path__ + "static/media/cafe.71e481d1.jpg";